module.exports = __webpack_public_path__ + "images/04a44b595e2a55977c40e94ee5c9ab90.svg";